import React from 'react';
import { Button, DatePicker } from 'antd';
import './style.js';
import moment from 'moment';
import { ModalBody } from './style.js';
import { useHideModal } from 'hooks/modal.js';
import { useFormik } from 'formik';
import { validationSchema } from 'views/Supervisor/helper.js';

const { RangePicker } = DatePicker;

export default ({ id, handleSubmit }) => {
  const { hideModal } = useHideModal();

  const handleChangeDateInput = (_, dateString) => {
    const data = [
      moment(dateString[0]).format('YYYY-MM-DD'),
      moment(dateString[1]).format('YYYY-MM-DD'),
    ];
    formik.setFieldValue('date', data);
  };

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      date: [],
    },
    onSubmit: (values) => {
      handleSubmit(id, values);
    },
  });

  const handleOnFocus = () => {
    formik.setFieldValue('date', []);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <ModalBody>
        <div className='range-datepicker'>
          <RangePicker
            value={[
              formik.values.date[0] && moment(formik.values.date[0]),
              formik.values.date[1] && moment(formik.values.date[1]),
            ]}
            onClick={handleOnFocus}
            format='YYYY-MMM-DD'
            onChange={handleChangeDateInput}
          />
          {formik.errors.date && formik.touched.date && (
            <div className='error-message'>{formik.errors.date}</div>
          )}
        </div>
        <div className='action-button'>
          <Button
            htmlType='button'
            type='primary'
            size='large'
            danger
            style={{
              backgroundColor: '#f64e60',
              color: 'rgb(255,255,255)',
              border: '1px solid #f0f0f0',
              borderRadius: '10px',
            }}
            onClick={() => hideModal()}
          >
            Бекор қилиш
          </Button>
          <Button
            htmlType='submit'
            type='primary'
            size='large'
            style={{
              backgroundColor: 'rgb(51, 128, 255)',
              color: 'rgb(255,255,255)',
              border: '1px solid #f0f0f0',
              borderRadius: '10px',
            }}
          >
            Янгилаш
          </Button>
        </div>
      </ModalBody>
    </form>
  );
};
